import { styled } from '@mui/material';

export const Root = styled('div')({
  width: '100%',
  height: '100%',
});
